<template>
  <div class="assetManagement-payment-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="project-table">
      <avue-crud
        :option="option"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchReset"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @selection-change="selectionChange"
      >
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="save(row)">保存</el-button>
          <!--  <el-button type="primary"  @click="openFilter">
                  <a-icon type="filter" /> 高级筛选
                </el-button> -->
        </template>

        <template slot="contractName" slot-scope="{ row }">
          <div class="project-name" @click="handleDetail(row)">
            {{ row.contractName }}
          </div>
        </template>
        <template slot="menuLeft">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="handleAdd"
          >
            新建付款
          </el-button>
            <!-- v-if="permission.factoringCcollectionManage_writeoff" -->
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            plain
            v-if="permission.fundProjectListEdit"
            :disabled="disabled || selectionList.length > 1"
            @click.stop="handleEdit()"
            >编辑
          </el-button>

          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            v-if="permission.fundProjectListDel"
            :disabled="disabled"
            @click.stop="handleDelete()"
            >删除
          </el-button>

          <!-- <el-button size="small" icon="el-icon-download" @click="exportShow"
            >导出数据
          </el-button> -->
        </template>
      </avue-crud>
    </div>

    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>
<script>
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import ExportData from "@/components/exportData/exportData";
// import SelectPerson from "@/components/SelectPersonnel/person";
// import SelectDepartment from "@/components/SelectDepartment/department";
import { manageListConfig } from "./config.js";
import { getFundPaymentList, delFundPayment } from '@/api/zg/zg'
import { mapGetters } from "vuex";
export default {
  name: "fundProjectList",
  data() {
    return {
      drawer: false,
      tableData: [],
      form: {},
      searchForm: {},
      checkUserList: [],
      checkdepartment: [],
      option: manageListConfig(
        this.getMoney
      ),
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      selectionList: [],
      disabled: true,
      timepic: [],
    };
  },
  components: {
    TagsCloud,
    ExportData,
  },
  computed: {
    ...mapGetters(["userInfo", "permission"]),
  },
  watch: {
    selectionList: {
      handler(data) {
        let list = data.filter((item) => {
          return this.userInfo.user_id == item.managerUser
        });
        this.disabled = list.length != data.length || data.length == 0;
      },
      deep: true,
    },
  },
  mounted() {

  },
  methods: {
    async showWriteOff() {
      let that = this;
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行核销");
      } else if (this.selectionList.length == 1) {
        let data = this.selectionList[0];
        if (data.isWriteoff == 0) {
          let res = await queryCollectionDetail({ id: data.id });
          if (res.data.code == 200) {
            this.dialogVisble = true;
            this.paymentList.map((item, index) => {
              Object.assign(item, {
                collectionBankId: "",
                collectionMoney: "",
                collectionDate: "",
                collectionId: "",
              });
              if (this.$refs.bankOpenNameRef)
                this.$refs.bankOpenNameRef[index].reset();

              if (this.$refs.paymentInfo)
                this.$refs.paymentInfo[index].clearValidate();
            });
            this.collectionData = res.data.data;
          }
        } else {
          this.$message({
            type: "warning",
            message: `该条数据已核销`,
          });
        }
      } else {
        this.$message.error("请选择一条数据进行核销");
      }
    },
    cloudTages(data) {
      this.searchForm = {};
      this.timepic = [];
      this.searchForm = data;
      if (this.searchForm.startDate) {
        this.timepic = [
          this.searchForm.applyTimeBegin,
          this.searchForm.applyTimeEnd,
        ];
      }
      this.searchChange();
    },

    handleAdd() {
      this.$router.push({
        path: `/zg/fund/payment/add`,
      });
    },

    handleDetail(row) {
      this.$router.push({
        path: `/zg/fund/payment/detail/${row.id}`,
      });
    },

    handleEdit() {
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行编辑");
      } else if (this.selectionList.length == 1) {
        let data = this.selectionList[0];
        if (data.auditStatus == 0) {
          // if (data.managerUser == this.userInfo.user_id) {
            this.$router.push({
              path: `/zg/fund/payment/detail/${data.id}`,
            });
          // } else {
          //   this.$message.warning("您暂无权限对该条数据进行编辑");
          // }
        } else {
          this.$message.warning("该条数据已提交审核无法编辑");
        }
      } else {
        this.$message.error("请选择一条数据进行编辑");
      }
    },

    async queryTableData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
      };
      let res = await getFundPaymentList(params);
      if (res.data.code == 200) {
        let list = res.data.data.records;

        this.tableData = list;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },

    //搜索
    searchChange(params, done) {
      this.searchForm = params;
      this.page.currentPage = 1;
      this.queryTableData();
      done();
    },

    //清空
    searchReset() {
      this.searchForm = {};
      this.checkUserList = [];
      this.timepic = [];
      this.queryTableData();
    },

    //选择项发生变化 传入数组
    selectionChange(list) {
      this.selectionList = list;
    },

    handleDelete() {
      let self = this;
      if (this.selectionList.length > 0) {
        let index = 0;

        this.selectionList.map((item) => {
          if (item.managerUser == this.userInfo.user_id) {
            index += 1;
          }
        });

        if (index != this.selectionList.length) {
          this.$message.warning("您没有权限删除此条数据");
          return;
        }
      
        this.$confirm("确定删除选择的数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            let ids = this.selectionList.map((item) => {
              return item.id;
            });

            let res = await delFundPayment({
              ids: ids.join(","),
            });
            if (res.data.code == 200) {
              self.$message({
                type: "success",
                message: "删除成功",
              });
              self.queryTableData();
            }
          })
          .catch(() => {
            self.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message.error("请选择数据进行删除");
      }
    },
    save(row) {
      this.$refs.cloudtage.save(row);
    },
  },
};
</script>
<style lang="scss" scoped>
.assetManagement-payment-container {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #409eff;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
  .project_name {
    color: #409eff;
  }
  .quota-status {
    position: relative;
    padding-left: 20px;
  }
  .quota-status::before {
    position: absolute;
    content: "";
    background-color: #19b16b;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    left: 12px;
    top: 7px;
  }
  .red-point::before {
    color: #f56c6c !important;
  }
}
/deep/ .avue-group--card {
  padding: 0 !important;
}
/deep/ .avue-form__menu {
  width: auto !important;
}
/deep/ .avue-form__row {
  padding-left: 0 !important;
}
</style>